import { createStyles, makeStyles } from "@material-ui/styles";
import { RelodeTheme } from "../";

export const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                display: "flex",
                flexDirection: "column",
                height: "100%",
                width: "100%",
                overflow: "hidden",
            },
            closed: {
                width: 0,
            },
            header: {
                flexGrow: 0,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#f3f3f3",
                padding: 8,
                height: 64,
            },
            appBar: {
                boxShadow: "none",
                borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                paddingLeft: 0,
                paddingRight: 0,
                display: "flex",
                flexDirection: "row",
                justifyContent: "stretch",
            },
            toolbar: {
                paddingLeft: theme.spacing(2),
                paddingRight: 0,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                flexGrow: 1,
            },
            content: {
                padding: 0,
                position: "relative",
                flexGrow: 1,
            },
            drawer: {
                width: 300,
                marginRight: 0,
                transition: theme.transitions.create(["margin-right"], {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.enteringScreen,
                }),
            },
            drawerPaper: {
                width: 300,
                marginRight: 0,
                overflowX: "hidden",
                transition: theme.transitions.create(["margin-right"], {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.enteringScreen,
                }),
            },
            drawerClosed: {
                marginRight: -300,
                transition: theme.transitions.create(["margin-right"], {
                    easing: theme.transitions.easing.easeIn,
                    duration: theme.transitions.duration.leavingScreen,
                }),
            },
            floatRight: {
                boxShadow: "rgba(200,200,200,1) -4px 8px 30px 0",
                marginRight: 0,
                zIndex: 16000,
            },
        }),
    { name: "Drawer" }
);
